//  myProject SLIDER JS
var swiper = new Swiper(".myProject", {
    slidesPerView: 5,
    spaceBetween: 22,
    loop: true,
    
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    speed: 1000,
    breakpoints: {
        1550: {
            slidesPerView: 5,
            spaceBetween: 22,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 22,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        200: {
            slidesPerView: 1,
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {
  // 🌀 Initialize Swiper
  const thumbs = new Swiper(".SingleProductThumbs", {
    spaceBetween: 10,
    watchSlidesProgress: true,

    breakpoints: {
      // Mobile (0px – 575px)
      0: {
        slidesPerView: 2,
      },

      // Small devices (576px – 767px)
      576: {
        slidesPerView: 3,
      },

      // Tablets (768px – 991px)
      768: {
        slidesPerView: 3,
      },

      // Desktop (992px and above)
      992: {
        slidesPerView: 4,
      }
    }
  });


  const mainSwiper = new Swiper(".SingleProduct", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: { swiper: thumbs },
  });

  // 🔍 Zoom effect on hover
  const zoomImages = document.querySelectorAll(".zoomable");
  zoomImages.forEach(img => {
    img.addEventListener("mousemove", function (e) {
      const rect = img.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = "scale(2)";
    });
    img.addEventListener("mouseleave", function () {
      img.style.transformOrigin = "center";
      img.style.transform = "scale(1)";
    });
  });

  // 🛒 Add to Cart Button Animation
  const form = document.querySelector(".add-to-cart-form");
  const btn = document.querySelector(".add-to-cart-btn");
  const feedback = document.querySelector(".cart-feedback");

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    btn.classList.add("loading");
    feedback.textContent = "Adding...";
    feedback.classList.add("show");

    // Simulate Add to Cart Success
    setTimeout(() => {
      btn.classList.remove("loading");
      feedback.textContent = "Added to Cart!";
      feedback.classList.add("success");

      setTimeout(() => {
        feedback.classList.remove("show", "success");
      }, 2000);
    }, 1200);
  });
});

//Cart Menu Entry
$(".Cart-btn a").click(function () {
    $(".Cart-menu-inner").addClass("active");
});

//Cart Menu Exit
$(".Cart-logo-main a").click(function () {
    $(".Cart-menu-inner").removeClass("active");
});


 // CART FUNCTION
    document.addEventListener('DOMContentLoaded', function () {
      const cartMenu = document.querySelector('.Cart-menu-inner');
      const overlay = document.querySelector('.cart-overlay');
      const cartList = document.querySelector('.cart-list');
      const subtotalEl = document.querySelector('.cart-subtotal');

      // 🛒 Intercept Add to Cart
      document.body.addEventListener('submit', function (e) {
        if (e.target.matches('form.add-cart')) {
          e.preventDefault();

          fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(e.target),
          })
          .then(res => res.json())
          .then(() => {
            updateCart(); // Refresh cart data
            cartMenu.classList.add('active'); // Show your custom cart drawer
            overlay?.classList.add('active'); // Show overlay if exists
          })
          .catch(err => {
            console.error('Error adding to cart:', err);
            alert('There was a problem adding this product to the cart.');
          });
        }
      });

      // 🧾 Update cart contents
      function updateCart() {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => renderCart(cart));
      }

      // 🧱 Render the cart
      function renderCart(cart) {
        cartList.innerHTML = '';
        if (!cart.items || cart.items.length === 0) {
          cartList.innerHTML = '<li><p>Your cart is empty 😔</p></li>';
          subtotalEl.textContent = '0.00';
          return;
        }

        let subtotal = 0;
        cart.items.forEach(item => {
          subtotal += item.final_line_price;

          const li = document.createElement('li');
          li.className = 'cart-product';
          li.innerHTML = `
            <div class="product-thumb-info">
              <div class="img">
                <a href="${item.url}">
                  <img src="${item.image}" alt="${item.product_title}">
                </a>
              </div>
              <div class="content">
                <h4><a href="${item.url}">${item.product_title}</a></h4>
                <span class="item-cat"><small>${item.variant_title || ''}</small></span>
                <span class="price">${(item.final_line_price / 100).toFixed(2)} USD</span>
                <span class="qty">Qty: ${item.quantity}</span>
                <a href="#" class="product-remove" data-id="${item.key}">
                  <i class="far fa-trash-alt"></i>
                </a>
              </div>
            </div>
          `;
          cartList.appendChild(li);
        });

        subtotalEl.textContent = (subtotal / 100).toFixed(2);
        bindDeleteEvents();
      }

      // 🗑 Remove item from cart
      function bindDeleteEvents() {
        document.querySelectorAll('.product-remove').forEach(btn => {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            const id = this.dataset.id;

            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: id, quantity: 0 }),
            })
            .then(res => res.json())
            .then(cart => renderCart(cart));
          });
        });
      }
    });

    // Cursor pointer

function mousemoveHandler(e) {
  try {
    const target = e.target;

    let tl = gsap.timeline({
      defaults: {
        x: e.clientX,
        y: e.clientY,
      }
    })
    let t2 = gsap.timeline({
      defaults: {
        x: e.clientX,
        y: e.clientY,
      }
    })


    // Main Cursor Moving 

    tl.to(".cursor1", {
      ease: "power2.out"
    })
      .to(".cursor2", {
        ease: "power2.out"
      }, "-=0.4")

  } catch (error) {
    console.log(error)
  }

}
document.addEventListener("mousemove", mousemoveHandler);

// responsive-menu-dropdown-links

$('.resp-menu-item ul li .more').click(function () {
  $('.resp-menu-item ul li .more').not(this).children('i').removeClass('active');
  $(this).children('i').toggleClass('active');
  $('.resp-menu-item ul li ul').not($(this).next()).slideUp();
  $(this).siblings('ul').slideToggle();
});

// responsive-entry-function

$('.menu-box a').click(function(){
    $('.responsive-menu').addClass('active');
});

// responsive-exit-function

$('.cross-btn a').click(function(){
    $('.responsive-menu').removeClass('active');
});


// === SEARCH POPUP JS ===
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openSearch");
  const closeBtn = document.getElementById("closeSearch");
  const overlay = document.getElementById("searchOverlay");

  if (openBtn && closeBtn && overlay) {
    // Open popup
    openBtn.addEventListener("click", () => {
      overlay.classList.add("active");
      document.body.style.overflow = "hidden"; // prevent scroll
      setTimeout(() => {
        overlay.querySelector(".search-input").focus();
      }, 200);
    });

    // Close popup
    closeBtn.addEventListener("click", () => {
      overlay.classList.remove("active");
      document.body.style.overflow = "";
    });

    // Close on overlay click
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.classList.remove("active");
        document.body.style.overflow = "";
      }
    });

    // Close on ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        overlay.classList.remove("active");
        document.body.style.overflow = "";
      }
    });
  }
});
